<ng-container *transloco="let t">
  <div class="d-flex flex-nowrap align-items-center share-buttons-wrapper">
    @if (isShareVisible) {
      <div class="pe-2 pe-xl-4">
        <share-buttons [theme]="'default'"
                       [include]="['facebook','linkedin','pinterest','whatsapp']"
                       [show]="4" [title]="label ?? ''" [description]="description ?? ''"
                       [image]="eventItem?.imageIcon ?? ''" [url]="document.location.href ?? ''"
                       [autoSetMeta]="true" />
      </div>
    }
    @if(eventItem?.favorite && !isPreviewComponent){
      <img src="assets/icons/red-heart.svg" alt="Heart" class="fav-icon"
      (click)="addToFavoritesButtonClicked()" />
    }@else{
      <img src="assets/icons/red-outlined-heart.svg" alt="Heart" class="fav-icon"
      (click)="addToFavoritesButtonClicked()" />
    }
  </div>
</ng-container>
